<template>
  <a-modal
    v-model:visible="visible"
    :title="`新建重定向`"
    @ok="() => {}"
    @cancel="visible = false"
    style="width: 800px;"
  >
    <a-form ref="formRef" :model="state" layout="vertical" :rules="rules">
      <a-form-item
        name="redirectFrom"
        label="重定向自"
        extra="此为您希望重定向的原始URL,设置后用户无法访问此URL"
      >
        <a-input
          class="w400"
          :maxlength="255"
          v-model:value="state.redirectFrom"
          placeholder="请输入(如:/collections/bikinis)"
        />
      </a-form-item>
      <a-form-item
        name="redirectTo"
        label="重定向至"
        extra="将访问者转发到新URL"
      >
        <a-input
          class="w400"
          :maxlength="255"
          v-model:value="state.redirectTo"
          placeholder="请输入(如:/collections/bikinis)"
        />
      </a-form-item>
      <a-form-item name="scene" label="场景">
        <a-input
          class="w400"
          v-model:value="state.scene"
          :maxlength="255"
          placeholder="请输入"
        />
      </a-form-item>
      <a-form-item required name="statusCode" label="状态码">
        <a-select
          v-model:value="state.statusCode"
          style="width: 400px;"
          placeholder="请选择"
        >
          <a-select-option value="301">301</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <template #footer>
      <div class="tar">
        <a-button type="default" @click="visible = false">取消</a-button>
        <a-button type="primary" @click="addListData">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { inject, toRefs, reactive, ref, watch } from 'vue'
import { redirect_add_post } from '@/server/modules/798'
import { message } from 'ant-design-vue'

export default {
  setup() {
    const formRef = ref()
    const initState = inject('initState')
    const state = reactive({
      redirectFrom: '',
      redirectTo: '',
      scene: '',
      statusCode: ''
    })

    const rules = {
      redirectFrom: [
        {
          required: true,
          message: '重定向自不能为空'
        },
        {
          // eslint-disable-next-line no-useless-escape
          pattern: /^\/[a-zA-Z0-9\-\/?=]*$/,
          message: '必须以/开头，只能包含数字,英文字母,/,-,=,?'
        }
      ],
      statusCode: [
        {
          required: true,
          message: '状态码不能为空'
        }
      ],
      redirectTo: [
        {
          required: true,
          message: '重定向至不能为空'
        },
        {
          // eslint-disable-next-line no-useless-escape
          pattern: /^\/[a-zA-Z0-9\/\?\-=&]*$/,
          message: '必须以/开头，只能包含数字,英文字母,/,-,?,=,&'
        }
      ]
    }

    const addListData = async () => {
      try {
        await formRef.value.validate()
        const params = {
          ...initState.searchParams,
          ...state
        }
        const { success, retInfo } = await redirect_add_post(params)
        if (!success) {
          return message.error(retInfo)
        }
        formRef.value.resetFields()
        initState.visible = false
        initState.initList(1)
      } catch (e) {
        console.log(e)
      }
    }

    watch(
      () => initState.visible,
      value => {
        if (!value) {
          formRef.value.resetFields()
        }
      }
    )

    return {
      ...toRefs(initState),
      formRef,
      state,
      addListData,
      rules
    }
  }
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
